import { Dialog, Divider, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { ArrowBack, Close } from "@mui/icons-material";
import { PrivateMainLayout } from "../layout";

interface MobileProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  /** Segunda etapa de fluxo: seta à esquerda do título (ex.: voltar aos dados fitness). */
  onBack?: () => void;
  subtitle?: string;
  /** Soma ao z-index do modal — necessário acima de `MobileBottomSheet` (ex.: questionários). */
  zIndexOffset?: number;
}

/**
 * Tela mobile exclusiva em fullscreen — documentos, agenda, família, etc.
 * (Formulários curtos usam `MobileBottomSheet` via `CommonDialog`.)
 */
export function ScreenMobile({
  title,
  open,
  onClose,
  children,
  onBack,
  subtitle,
  zIndexOffset = 0,
}: MobileProps) {
  const theme = useTheme();

  return (
    <Dialog
      fullScreen
      open={open}
      disableScrollLock
      sx={
        zIndexOffset > 0
          ? { zIndex: theme.zIndex.modal + zIndexOffset }
          : undefined
      }
    >
      <PrivateMainLayout noSidebar>
        <Stack
          direction="column"
          alignItems="flex-start"
          width="100%"
          height="100%"
          sx={{ minHeight: 0 }}
        >
          <Stack
            width="100%"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ borderRadius: 8, px: 2, mb: 1, boxShadow: "0px 0px 24px 4px rgba(0, 0, 0, 0.1)" }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ flex: 1, minWidth: 0 }}
            >
              {onBack ? (
                <IconButton
                  size="small"
                  aria-label="Voltar"
                  onClick={onBack}
                  sx={{ color: "neutral1000.main", flexShrink: 0 }}
                >
                  <ArrowBack />
                </IconButton>
              ) : null}
              <Stack sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  variant="subtitle2"
                  color="neutral700.main"
                  fontWeight={600}
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {title}
                </Typography>
                {subtitle ? (
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {subtitle}
                  </Typography>
                ) : null}
              </Stack>
            </Stack>
            <IconButton
              sx={{ color: "neutral1000.main", flexShrink: 0 }}
              onClick={onClose}
              aria-label="Fechar"
            >
              <Close />
            </IconButton>
          </Stack>
          <Stack
            sx={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              overflow: "auto",
            }}
          >
            {children}
          </Stack>
        </Stack>
      </PrivateMainLayout>
    </Dialog>
  );
}
